import React, { memo } from "react"
// import MoreButtonArrowIcon from "../../svg/MoreButtonArrowIcon"
import * as style from "./linkButtonMore.module.css"
import LinkArrow from "../../svg/new/LinkArrow"

const LinkButtonMore = ({ btnText, Btnclass }) => {
  return (
    <span className={`${style.btn_more} ${Btnclass}`}>
      {btnText}
      <i>
        <LinkArrow />
      </i>
    </span>
  )
}

export default memo(LinkButtonMore)
